import React from 'react'
import {
  rootRoute,
  friendsRoute,
  historyRoute,
  homeRoute,
  logoutRoute,
  loginRoute,
  profileRoute,
  walletRoute,
} from '../routes/routes'

import ReceiptIcon from '@material-ui/icons/ReceiptOutlined'
import AccountBalanceIcon from '@material-ui/icons/AccountBalanceWalletOutlined'
import PeopleIcon from '@material-ui/icons/PeopleAltOutlined'
import LogoutIcon from '@material-ui/icons/ExitToAppOutlined'
import HomeIcon from '@material-ui/icons/StorefrontOutlined'

const data = {
  adminMenu: [
    {
      copy: 'Foodsby Admin',
      href: `${process.env.REACT_APP_NEW_FOODSBY_ADMIN_URL}`,
    },
    {
      copy: 'Foodsby Admin (Old)',
      href: `${process.env.REACT_APP_FOODSBY_BASE_URL}/admin/login`,
    },
    {
      copy: 'Stats',
      href: process.env.REACT_APP_STATS_URL,
    },
  ],
  foodsbyOne: [
    {
      copy: 'Foodsby One',
      href: process.env.REACT_APP_FOODSBY_ONE,
    },
  ],
  headerMenu: [
    {
      copy: 'Profile',
      href: profileRoute.path,
    },
    {
      copy: 'Home',
      href: rootRoute.path,
      icon: <HomeIcon />,
    },
    {
      copy: 'Order History',
      href: historyRoute.path,
      icon: <ReceiptIcon />,
    },
    {
      copy: 'Wallet',
      href: walletRoute.path,
      icon: <AccountBalanceIcon />,
    },
    {
      copy: 'Friends',
      href: friendsRoute.path,
      icon: <PeopleIcon />,
    },
  ],
  logout: [
    {
      copy: 'Log Out',
      href: logoutRoute.path,
      icon: <LogoutIcon />,
    },
  ],
  simpleMenu: [
    {
      copy: 'My Home',
      href: homeRoute.path,
    },
    {
      copy: 'Log In',
      href: loginRoute.path,
    },
  ],
}

export default data
